import { I18n } from "@assets/strings";
import React from "react";
import { useOrganizationMembers } from "@domain/user/hooks";
import { MembersList } from "@ui/components/profile/community/memberList";

interface TeachersListProps extends React.HTMLAttributes<HTMLDivElement> {
	organizationId: string;
	onShouldSeeMore: () => void;
}
export const TeachersList: React.FC<TeachersListProps> = ({ organizationId, onShouldSeeMore, ...htmlProps }) => {
	const { result: teachers, totalElements } = useOrganizationMembers(organizationId, "CONTRIBUTOR");

	return (
		<MembersList
			{...htmlProps}
			members={teachers}
			totalElements={totalElements}
			onShouldSeeMore={onShouldSeeMore}
			title={I18n.t("organization.teachers.list.title", { count: totalElements ?? 0 })}
			emptyText={I18n.t("organization.teachers.list.empty")}
		/>
	);
};
